import {createNotificationComponent} from '@vfde-brix/notification';
import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix/core';
import {YOUNG_S_GROUP} from '@vfde-fe/sails-constants';

/**
 * mountNotification
 * @param notificationContainerId
 */
export const mountNotification = (notificationContainerId) => {
    const container = document.getElementById(notificationContainerId);

    return createNotificationComponent(container, NO_PATTERN_BUSINESS_LOGIC);
};
